<ng-container *ngIf="educationAndTraining$ | async as educationAndTraining">
    <div class="page-container page-container-vertical">
        <isav-unpublished-warning
            [published]="!educationAndTraining.draft"
            contentName="Education & Training"
            myContentPath="my-education-and-trainings"
        ></isav-unpublished-warning>
        <isav-notes *isavAuthenticated="true" [iri]="educationAndTraining['@id']"></isav-notes>
        <isav-add-note
            [(hidden)]="hidden"
            [contentIri]="educationAndTraining['@id']"
        ></isav-add-note>
        <isav-action-title
            [title]="educationAndTraining.title | isavTitleFallback : educationAndTraining['@id']"
        >
            <a
                *isavHasEditAccess="educationAndTraining['@id']"
                [isavEditLink]="educationAndTraining"
                isavEditLinkProperty="title"
                isavBtn
                color="primary"
            >
                Edit
            </a>
            <button
                *isavHasCreateAccess="'EducationAndTraining'"
                [isavCloneContent]="educationAndTraining['@id']"
                isavBtn
                color="primary"
            >
                Clone
            </button>
            <button
                (click)="hidden = false"
                *isavAuthenticated="true"
                type="button"
                isavBtn
                color="primary"
            >
                Write note
            </button>
            <button isavBtn color="primary" isavPrintPage>Print page</button>
        </isav-action-title>
    </div>

    <isav-content-type-view>
        <isav-caption> Data Information </isav-caption>
        <div isavContentTypeDetails>
            <p>
                <strong>Course start date: </strong> {{ educationAndTraining.startDate | isavDate}}
            </p>
            <p><strong>Course end date: </strong> {{ educationAndTraining.endDate | isavDate }}</p>
            <p>
                <strong>Registration deadline: </strong> {{
                educationAndTraining.registrationDeadline | isavDate }}
            </p>
            <p>
                <span class="has-text-weight-bold">Organisation: </span>
                <isav-taxonomies-external-link
                    [iris]="[educationAndTraining.organisation]"
                ></isav-taxonomies-external-link>
            </p>
            <p>
                <span class="has-text-weight-bold">Departments: </span>
                <isav-taxonomies-external-link
                    [iris]="educationAndTraining.departments"
                ></isav-taxonomies-external-link>
            </p>
            <p *ngIf="educationAndTraining.education">
                <strong>Field of study: </strong>
                <isav-taxonomies-names
                    [iris]="[educationAndTraining.studyField]"
                ></isav-taxonomies-names>
            </p>
            <p *ngIf="educationAndTraining.education">
                <strong>Course level: </strong>
                <isav-taxonomies-names
                    [iris]="[educationAndTraining.courseLevel]"
                ></isav-taxonomies-names>
            </p>
            <p>
                <strong>Course topics: </strong>
                <isav-taxonomies-names [iris]="educationAndTraining.topics"></isav-taxonomies-names>
            </p>
            <p>
                <strong>Teaching languages: </strong>
                <isav-taxonomies-names
                    [iris]="educationAndTraining.languages"
                ></isav-taxonomies-names>
            </p>
            <p>
                <strong>Teaching country: </strong>
                <isav-taxonomies-names
                    [iris]="[educationAndTraining.teachingCountry]"
                ></isav-taxonomies-names>
            </p>
            <p>
                <strong>Teaching location: </strong>
                {{ educationAndTraining.teachingLocation | isavGeoLocation }}
            </p>
            <p *ngIf="educationAndTraining.education">
                <strong>ECTS: </strong>
                {{ educationAndTraining.ects }}
            </p>
            <p *ngIf="educationAndTraining.linkToCourseRegistration">
                <strong>Link to course description: </strong>
                <isav-external-link
                    [link]="educationAndTraining.linkToCourseRegistration"
                ></isav-external-link>
            </p>
            <p>
                <strong>Attachments:&nbsp;</strong>
                <isav-files-link [iris]="educationAndTraining.attachments"></isav-files-link>
            </p>
            <h2 class="title is-1 mt-6">
                <span *ngIf="educationAndTraining.education">Education details</span>
                <span *ngIf="!educationAndTraining.education">Training details</span>
            </h2>
            <isav-description-display
                [title]="educationAndTraining.title || ''"
                [content]="educationAndTraining.shortDescription"
            ></isav-description-display>
        </div>
        <div isavContentTypeAside>
            <isav-contact-information
                [contactName]="educationAndTraining.contactName"
                [contactEmail]="educationAndTraining.contactEmail"
                [contactPhone]="educationAndTraining.contactPhone"
            ></isav-contact-information>
            <img
                *ngIf="educationAndTraining.image"
                [isavApiImg]="educationAndTraining.image"
                alt=""
                aria-hidden="true"
                class="is-fullwidth is-containing is-max-vh"
            />
            <isav-image-caption [iri]="educationAndTraining.image"></isav-image-caption>
        </div>
    </isav-content-type-view>

    <isav-page-content>
        <isav-domain-event-journal-list
            [iri]="educationAndTraining['@id']"
        ></isav-domain-event-journal-list>
    </isav-page-content>
</ng-container>
